import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import { legacyUpdateQueryList } from '../utils/graphql/updateQueryList';

// eslint-disable-next-line slab-graphql/no-unused-fields
gql(`
  fragment useInviteMutation_invitation on Invitation {
    id
    name
    email
    avatar {
      thumb
      original
    }
    provision {
      id
      type
    }
    inviter {
      id
    }
    status
  }
`);

const INVITE_MUTATION = gql(/** @complexity 8 */ `
  mutation invite(
    $email: String!
    $name: String
    $provisionId: ID
    $message: String
    $provisionChanges: ProvisionChangesInput
    $source: InvitationSource
  ) {
    invite(
      email: $email
      name: $name
      provisionId: $provisionId
      message: $message
      provisionChanges: $provisionChanges
      source: $source
    ) {
      ...useInviteMutation_invitation
    }
  }
`);

// eslint-disable-next-line slab-graphql/no-unused-fields
const ORG_INVITATIONS_UPDATE_QUERY = gql(/** @complexity 10 */ `
  query orgInvitationsUpdate {
    currentSession {
      organization {
        id
        invitations {
          ...useInviteMutation_invitation
        }
      }
    }
  }
`);

const useInviteMutation = () => {
  const [invite] = useMutation(INVITE_MUTATION, {
    update: legacyUpdateQueryList(
      { query: ORG_INVITATIONS_UPDATE_QUERY },
      'currentSession.organization.invitations',
      'invite',
      true,
    ),
  });

  return invite;
};

export default useInviteMutation;
